function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { isArray } from 'vega-util';
import { isFieldDef, isValueDef, vgField } from '../../channeldef';
import { DataSourceType } from '../../data';
import { pathGroupingFields } from '../../encoding';
import { AREA, BAR, LINE, TRAIL, isPathMark } from '../../mark';
import { contains, getFirstDefined, isNullOrFalse, keys, omit, pick } from '../../util';
import { VG_CORNERRADIUS_CHANNELS } from '../../vega.schema';
import { getMarkConfig, getMarkPropOrConfig, getStyles, signalOrValueRef, sortParams } from '../common';
import { arc } from './arc';
import { area } from './area';
import { bar } from './bar';
import { geoshape } from './geoshape';
import { image } from './image';
import { line, trail } from './line';
import { circle, point, square } from './point';
import { rect } from './rect';
import { rule } from './rule';
import { text } from './text';
import { tick } from './tick';
var markCompiler = {
  arc: arc,
  area: area,
  bar: bar,
  circle: circle,
  geoshape: geoshape,
  image: image,
  line: line,
  point: point,
  rect: rect,
  rule: rule,
  square: square,
  text: text,
  tick: tick,
  trail: trail
};
export function parseMarkGroups(model) {
  if (contains([LINE, AREA, TRAIL], model.mark)) {
    var details = pathGroupingFields(model.mark, model.encoding);
    if (details.length > 0) {
      return getPathGroups(model, details);
    }
    // otherwise use standard mark groups
  } else if (model.mark === BAR) {
    var hasCornerRadius = VG_CORNERRADIUS_CHANNELS.some(function (prop) {
      return getMarkPropOrConfig(prop, model.markDef, model.config);
    });
    if (model.stack && !model.fieldDef('size') && hasCornerRadius) {
      return getGroupsForStackedBarWithCornerRadius(model);
    }
  }
  return getMarkGroup(model);
}
var FACETED_PATH_PREFIX = 'faceted_path_';
function getPathGroups(model, details) {
  // TODO: for non-stacked plot, map order to zindex. (Maybe rename order for layer to zindex?)
  return [{
    name: model.getName('pathgroup'),
    type: 'group',
    from: {
      facet: {
        name: FACETED_PATH_PREFIX + model.requestDataName(DataSourceType.Main),
        data: model.requestDataName(DataSourceType.Main),
        groupby: details
      }
    },
    encode: {
      update: {
        width: {
          field: {
            group: 'width'
          }
        },
        height: {
          field: {
            group: 'height'
          }
        }
      }
    },
    // With subfacet for line/area group, need to use faceted data from above.
    marks: getMarkGroup(model, {
      fromPrefix: FACETED_PATH_PREFIX
    })
  }];
}
var STACK_GROUP_PREFIX = 'stack_group_';
/**
 * We need to put stacked bars into groups in order to enable cornerRadius for stacks.
 * If stack is used and the model doesn't have size encoding, we put the mark into groups,
 * and apply cornerRadius properties at the group.
 */
function getGroupsForStackedBarWithCornerRadius(model) {
  var _model$stack$groupbyC;
  // Generate the mark
  var _getMarkGroup = getMarkGroup(model, {
      fromPrefix: STACK_GROUP_PREFIX
    }),
    _getMarkGroup2 = _slicedToArray(_getMarkGroup, 1),
    mark = _getMarkGroup2[0];
  // Get the scale for the stacked field
  var fieldScale = model.scaleName(model.stack.fieldChannel);
  var stackField = function stackField() {
    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return model.vgField(model.stack.fieldChannel, opt);
  };
  // Find the min/max of the pixel value on the stacked direction
  var stackFieldGroup = function stackFieldGroup(func, expr) {
    var vgFieldMinMax = [stackField({
      prefix: 'min',
      suffix: 'start',
      expr: expr
    }), stackField({
      prefix: 'max',
      suffix: 'start',
      expr: expr
    }), stackField({
      prefix: 'min',
      suffix: 'end',
      expr: expr
    }), stackField({
      prefix: 'max',
      suffix: 'end',
      expr: expr
    })];
    return "".concat(func, "(").concat(vgFieldMinMax.map(function (field) {
      return "scale('".concat(fieldScale, "',").concat(field, ")");
    }).join(','), ")");
  };
  var groupUpdate;
  var innerGroupUpdate;
  // Build the encoding for group and an inner group
  if (model.stack.fieldChannel === 'x') {
    // Move cornerRadius, y/yc/y2/height properties to group
    // Group x/x2 should be the min/max of the marks within
    groupUpdate = _objectSpread(_objectSpread({}, pick(mark.encode.update, ['y', 'yc', 'y2', 'height'].concat(_toConsumableArray(VG_CORNERRADIUS_CHANNELS)))), {}, {
      x: {
        signal: stackFieldGroup('min', 'datum')
      },
      x2: {
        signal: stackFieldGroup('max', 'datum')
      },
      clip: {
        value: true
      }
    });
    // Inner group should revert the x translation, and pass height through
    innerGroupUpdate = {
      x: {
        field: {
          group: 'x'
        },
        mult: -1
      },
      height: {
        field: {
          group: 'height'
        }
      }
    };
    // The marks should use the same height as group, without y/yc/y2 properties (because it's already done by group)
    // This is why size encoding is not supported yet
    mark.encode.update = _objectSpread(_objectSpread({}, omit(mark.encode.update, ['y', 'yc', 'y2'])), {}, {
      height: {
        field: {
          group: 'height'
        }
      }
    });
  } else {
    groupUpdate = _objectSpread(_objectSpread({}, pick(mark.encode.update, ['x', 'xc', 'x2', 'width'])), {}, {
      y: {
        signal: stackFieldGroup('min', 'datum')
      },
      y2: {
        signal: stackFieldGroup('max', 'datum')
      },
      clip: {
        value: true
      }
    });
    innerGroupUpdate = {
      y: {
        field: {
          group: 'y'
        },
        mult: -1
      },
      width: {
        field: {
          group: 'width'
        }
      }
    };
    mark.encode.update = _objectSpread(_objectSpread({}, omit(mark.encode.update, ['x', 'xc', 'x2'])), {}, {
      width: {
        field: {
          group: 'width'
        }
      }
    });
  }
  // Deal with cornerRadius properties
  var _iterator = _createForOfIteratorHelper(VG_CORNERRADIUS_CHANNELS),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      var configValue = getMarkConfig(key, model.markDef, model.config);
      // Move from mark to group
      if (mark.encode.update[key]) {
        groupUpdate[key] = mark.encode.update[key];
        delete mark.encode.update[key];
      } else if (configValue) {
        groupUpdate[key] = signalOrValueRef(configValue);
      }
      // Overwrite any cornerRadius on mark set by config --- they are already moved to the group
      if (configValue) {
        mark.encode.update[key] = {
          value: 0
        };
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var groupby = [];
  if (((_model$stack$groupbyC = model.stack.groupbyChannels) === null || _model$stack$groupbyC === void 0 ? void 0 : _model$stack$groupbyC.length) > 0) {
    var _iterator2 = _createForOfIteratorHelper(model.stack.groupbyChannels),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var groupbyChannel = _step2.value;
        // For bin and time unit, we have to add bin/timeunit -end channels.
        var groupByField = model.fieldDef(groupbyChannel);
        var field = vgField(groupByField);
        if (field) {
          groupby.push(field);
        }
        if (groupByField !== null && groupByField !== void 0 && groupByField.bin || groupByField !== null && groupByField !== void 0 && groupByField.timeUnit) {
          groupby.push(vgField(groupByField, {
            binSuffix: 'end'
          }));
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  var strokeProperties = ['stroke', 'strokeWidth', 'strokeJoin', 'strokeCap', 'strokeDash', 'strokeDashOffset', 'strokeMiterLimit', 'strokeOpacity'];
  // Generate stroke properties for the group
  groupUpdate = strokeProperties.reduce(function (encode, prop) {
    if (mark.encode.update[prop]) {
      return _objectSpread(_objectSpread({}, encode), {}, _defineProperty({}, prop, mark.encode.update[prop]));
    } else {
      var configValue = getMarkConfig(prop, model.markDef, model.config);
      if (configValue !== undefined) {
        return _objectSpread(_objectSpread({}, encode), {}, _defineProperty({}, prop, signalOrValueRef(configValue)));
      } else {
        return encode;
      }
    }
  }, groupUpdate);
  // Apply strokeForeground and strokeOffset if stroke is used
  if (groupUpdate.stroke) {
    groupUpdate.strokeForeground = {
      value: true
    };
    groupUpdate.strokeOffset = {
      value: 0
    };
  }
  return [{
    type: 'group',
    from: {
      facet: {
        data: model.requestDataName(DataSourceType.Main),
        name: STACK_GROUP_PREFIX + model.requestDataName(DataSourceType.Main),
        groupby: groupby,
        aggregate: {
          fields: [stackField({
            suffix: 'start'
          }), stackField({
            suffix: 'start'
          }), stackField({
            suffix: 'end'
          }), stackField({
            suffix: 'end'
          })],
          ops: ['min', 'max', 'min', 'max']
        }
      }
    },
    encode: {
      update: groupUpdate
    },
    marks: [{
      type: 'group',
      encode: {
        update: innerGroupUpdate
      },
      marks: [mark]
    }]
  }];
}
export function getSort(model) {
  var encoding = model.encoding,
    stack = model.stack,
    mark = model.mark,
    markDef = model.markDef,
    config = model.config;
  var order = encoding.order;
  if (!isArray(order) && isValueDef(order) && isNullOrFalse(order.value) || !order && isNullOrFalse(getMarkPropOrConfig('order', markDef, config))) {
    return undefined;
  } else if ((isArray(order) || isFieldDef(order)) && !stack) {
    // Sort by the order field if it is specified and the field is not stacked. (For stacked field, order specify stack order.)
    return sortParams(order, {
      expr: 'datum'
    });
  } else if (isPathMark(mark)) {
    // For both line and area, we sort values based on dimension by default
    var dimensionChannel = markDef.orient === 'horizontal' ? 'y' : 'x';
    var dimensionChannelDef = encoding[dimensionChannel];
    if (isFieldDef(dimensionChannelDef)) {
      return {
        field: dimensionChannel
      };
    }
  }
  return undefined;
}
function getMarkGroup(model) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    fromPrefix: ''
  };
  var mark = model.mark,
    markDef = model.markDef,
    encoding = model.encoding,
    config = model.config;
  var clip = getFirstDefined(markDef.clip, scaleClip(model), projectionClip(model));
  var style = getStyles(markDef);
  var key = encoding.key;
  var sort = getSort(model);
  var interactive = interactiveFlag(model);
  var aria = getMarkPropOrConfig('aria', markDef, config);
  var postEncodingTransform = markCompiler[mark].postEncodingTransform ? markCompiler[mark].postEncodingTransform(model) : null;
  return [_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    name: model.getName('marks'),
    type: markCompiler[mark].vgMark
  }, clip ? {
    clip: clip
  } : {}), style ? {
    style: style
  } : {}), key ? {
    key: key.field
  } : {}), sort ? {
    sort: sort
  } : {}), interactive ? interactive : {}), aria === false ? {
    aria: aria
  } : {}), {}, {
    from: {
      data: opt.fromPrefix + model.requestDataName(DataSourceType.Main)
    },
    encode: {
      update: markCompiler[mark].encodeEntry(model)
    }
  }, postEncodingTransform ? {
    transform: postEncodingTransform
  } : {})];
}
/**
 * If scales are bound to interval selections, we want to automatically clip
 * marks to account for panning/zooming interactions. We identify bound scales
 * by the selectionExtent property, which gets added during scale parsing.
 */
function scaleClip(model) {
  var xScale = model.getScaleComponent('x');
  var yScale = model.getScaleComponent('y');
  return xScale !== null && xScale !== void 0 && xScale.get('selectionExtent') || yScale !== null && yScale !== void 0 && yScale.get('selectionExtent') ? true : undefined;
}
/**
 * If we use a custom projection with auto-fitting to the geodata extent,
 * we need to clip to ensure the chart size doesn't explode.
 */
function projectionClip(model) {
  var projection = model.component.projection;
  return projection && !projection.isFit ? true : undefined;
}
/**
 * Only output interactive flags if we have selections defined somewhere in our model hierarchy.
 */
function interactiveFlag(model) {
  if (!model.component.selection) return null;
  var unitCount = keys(model.component.selection).length;
  var parentCount = unitCount;
  var parent = model.parent;
  while (parent && parentCount === 0) {
    parentCount = keys(parent.component.selection).length;
    parent = parent.parent;
  }
  return parentCount ? {
    interactive: unitCount > 0 || model.mark === 'geoshape' || !!model.encoding.tooltip || !!model.markDef.tooltip
  } : null;
}